import { triggerHaptic } from './haptics'

/**
 * Automatically add haptic feedback to all primary buttons
 * This function sets up a global click handler that detects primary buttons
 * and triggers haptic feedback automatically
 */
export function setupAutoHaptic() {
  // Check if we're on a native platform (haptics only work on native)
  const isNative = window.Capacitor && window.Capacitor.isNativePlatform()
  if (!isNative) {
    return // Skip on web platform
  }

  document.addEventListener('click', (e) => {
    const target = e.target
    
    // Traverse up the DOM to find the button element
    let element = target
    let buttonFound = false
    
    // Check up to 5 levels up to find the button (in case of nested elements like icons inside buttons)
    for (let i = 0; i < 5 && element && element !== document.body; i++) {
      const tagName = element.tagName?.toLowerCase()
      const isButton = tagName === 'button' || 
                      (tagName === 'a' && element.href) || 
                      element.getAttribute('role') === 'button'
      
      if (isButton) {
        buttonFound = true
        break
      }
      
      element = element.parentElement
    }
    
    if (!buttonFound || !element) return
    
    // Check for primary button indicators
    const classList = element.className || ''
    const isPrimaryButton = 
      classList.includes('primary-cta-button') ||
      classList.includes('action-button') ||
      classList.includes('bg-gold') ||
      classList.includes('bg-emerald-600') ||
      classList.includes('bg-emerald-700') ||
      classList.includes('bg-blue-500') ||
      classList.includes('bg-blue-600') ||
      classList.includes('bg-indigo-600') ||
      classList.includes('bg-gradient-to-r') ||
      (classList.includes('bg-') && (classList.includes('text-white') || classList.includes('font-bold')))
    
    if (isPrimaryButton) {
      triggerHaptic('light')
    }
  }, true) // Use capture phase to catch clicks early
}

